module.exports = __webpack_public_path__ + "img/animals.b118fb90.jpg";